export default "__VITE_ASSET__CoGOsPkZ__"